"use client"

import { Button } from "antd"
import { EyeOutlined, LogoutOutlined } from "@ant-design/icons"
import { useAuth } from "../contexts/AuthContext"

/**
 * Always-visible marker that the admin is acting as a customer.
 *
 * Nothing is blocked during an impersonation session — the admin can change the
 * customer's password, spend their wallet and place orders — so this banner is the
 * primary defence against acting on the wrong account by mistake. It lives in the app
 * shell and is deliberately hard to ignore: fixed to the top, full width, high
 * contrast, and it offsets the page so it can never be scrolled out of view.
 */
const ImpersonationBanner = () => {
  const { impersonation, stopImpersonation } = useAuth()

  if (!impersonation) return null

  return (
    <>
      <div
        role="alert"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2000,
          background: "#b45309",
          color: "#fff",
          padding: "10px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          flexWrap: "wrap",
          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          fontSize: 14,
        }}
      >
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <EyeOutlined />
          <strong>Operating as {impersonation.clientName}</strong>
          <span style={{ opacity: 0.85 }}>— actions are recorded and affect their real account</span>
        </span>
        <Button
          size="small"
          icon={<LogoutOutlined />}
          onClick={() => stopImpersonation(true)}
        >
          Exit
        </Button>
      </div>
      {/* Push the page down so the fixed banner never covers content. */}
      <div style={{ height: 44 }} />
    </>
  )
}

export default ImpersonationBanner
